export default "__VITE_ASSET__f64cad2c__"